import React from "react";
import styles from "./AlumniFAQ.module.scss";

const AlumniFAQ = ({ data }: any) => {
  return (
    <>
    {
      data && (
    <div className={`section_pading faq-sec ${styles.banner_join}`}>
      <div className="container">
        <h1 className="section_head">{data?.title}</h1>
        <p
          className="section_head_sub"
          dangerouslySetInnerHTML={{
            __html:
              data?.description?.content?.length > 0 &&
              data?.description?.content[0]?.content[0]?.text,
          }}
        />
        <div
          className="accordion accordion-flush accodian_alumni"
          id="accordionFlushExample"
        >
          {data?.accordions &&
            data?.accordions?.results?.length > 0 &&
            data?.accordions?.results?.map((value: any, index: number) => {
              const headingId = `flush-heading${index}`;
              const collapseId = `flush-collapse${index}`;
              return (
                <div className="accordion-item" key={index}>
                  <h2
                    className="accordion-header"
                    // id="flush-headingOne"
                    id={headingId}
                  >
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      // data-bs-target="#flush-collapseOne"
                      data-bs-target={`#${collapseId}`}
                      aria-expanded="false"
                      // aria-controls="flush-collapseOne"
                      aria-controls={collapseId}
                    >
                      {value?.accordionheader?.content?.length > 0 &&
                        value?.accordionheader?.content[0]?.content?.[0]?.text}
                    </button>
                  </h2>
                  <div
                    // id="flush-collapseOne"
                    id={collapseId}
                    className="accordion-collapse collapse"
                    // aria-labelledby="flush-headingOne"
                    aria-labelledby={headingId}
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div
                      className="accordion-body"
                      dangerouslySetInnerHTML={{
                        __html:
                          value?.accordionbody?.content?.length > 0 &&
                          value?.accordionbody?.content?.[0]?.content?.[0]
                            ?.text,
                      }}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
     )}
    </>
  );
};
export default AlumniFAQ;
